import React from 'react';
import { Heading } from '../../components';
import { FormattedMessage } from '../../util/reactIntl';

import css from './ListingPage.module.css';

const SectionSelectionProcess = props => {
  return (
    <section id="selectionProcess" className={css.section}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="ListingPage.selectionProcess" />
      </Heading>
      <div className={css.selectionProcessBlocks}>
        <div className={css.selectionProcessBlock}>
          <div className={css.selectionProcessBlockContainer}>
            <div className={css.selectionProcessBlockContent}>
              <h2>01</h2>
              <h3>Beworben als Nachhilfelehrkraft</h3>
              <p>Ich habe meine Fächer und meine Spezialisierung auf ADHS angegeben.</p>
            </div>
          </div>
        </div>
        <div className={css.selectionProcessBlock}>
          <div className={css.selectionProcessBlockContainer}>
            <div className={css.selectionProcessBlockContent}>
              <h2>02</h2>
              <h3>Spezialisierung validiert</h3>
              <p>Meine Erfahrung im Umgang mit ADHS wurde durch Studium und Praxis geprüft.</p>
            </div>
          </div>
        </div>
        <div className={css.selectionProcessBlock}>
          <div className={css.selectionProcessBlockContainer}>
            <div className={css.selectionProcessBlockContent}>
              <h2>03</h2>
              <h3>Fachgespräch mit dem Team</h3>
              <p>Dabei wurden meine Unterrichtserfahrung und mein pädagogischer Ansatz bewertet.</p>
            </div>
          </div>
        </div>
        <div className={css.selectionProcessBlock}>
          <div className={css.selectionProcessBlockContainer}>
            <div className={css.selectionProcessBlockContent}>
              <h2>04</h2>
              <h3>Start der Nachhilfe</h3>
              <p>Nach dem Auswahlprozess begleite ich Schüler*innen gezielt und spezialisiert.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionSelectionProcess;
